import { render, staticRenderFns } from "./GitDiff.vue?vue&type=template&id=45b14c3e"
import script from "./GitDiff.vue?vue&type=script&lang=js"
export * from "./GitDiff.vue?vue&type=script&lang=js"
import style0 from "./GitDiff.vue?vue&type=style&index=0&id=45b14c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports